export default "__VITE_ASSET__B6OW82HW__"